import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  checkAgentStatus,
  setCallDuration,
} from "../../../store/audioCall/audioCallSlice";

// This component handles the call timer and status check on mount.
// It should be rendered once in the layout (e.g., VerticalLayout).
function HeaderAudioCall() {
  const dispatch = useDispatch();
  const { callStatus, callDuration } = useSelector((state) => state.audioCall);
  const timerRef = useRef(null);
  const durationRef = useRef(callDuration);

  // Keep ref in sync
  useEffect(() => {
    durationRef.current = callDuration;
  }, [callDuration]);

  // Check call status on mount
  useEffect(() => {
    dispatch(checkAgentStatus());
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  // Timer for connected calls
  useEffect(() => {
    if (callStatus === "connected") {
      timerRef.current = setInterval(() => {
        dispatch(setCallDuration(durationRef.current + 1));
      }, 1000);
    } else {
      if (timerRef.current) { clearInterval(timerRef.current); timerRef.current = null; }
    }
    return () => { if (timerRef.current) clearInterval(timerRef.current); };
  }, [callStatus]);

  return null;
}

export default HeaderAudioCall;
